import * as XLSX from "xlsx";
export const exportToExcel = (title: string, data: any[]) => {
  // Headers
  const [headers, ...rows] = data;

  // Convertir rows en objetos
  const jsonData: Record<string, string | number>[] = rows.map(
    (row: (string | number)[]) => {
      const obj: Record<string, string | number> = {};

      headers.forEach((header: string | number, index: number) => {
        obj[String(header)] = row[index];
      });

      return obj;
    },
  );

  // Crear worksheet
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);

  // Crear workbook
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();

  // Agregar hoja
  XLSX.utils.book_append_sheet(workbook, worksheet, title);

  // Descargar archivo
  XLSX.writeFile(workbook, title + ".xlsx");
};
